<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <vx-card title="(구)입퇴원/외래">
            <div class="vx-row">
                <div class="vx-col w-full xl:w-1/1 mb-base text-center">
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-left" @click="prevMonth"></vs-button>
                    <span class="ml-5 mr-5">{{ nowDate }}</span>
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-right" @click="nextMonth"></vs-button>
                </div>
            </div>
            <div class="tb_wrap">
                <div class="tb_box" id="calendarDiv" style="width:100%;overflow-x:auto;height:900px;">
                    <table id="schedule" style="max-width:1200px; max-height:550px;" class="border-collapse calendar">
                        <colgroup>
                            <col width="25%" />
                            <col width="25%" />
                            <col width="25%" />
                            <col width="25%" />
                        </colgroup>
                        <tbody>
                            <td v-for="(item, index) in list" :key="index" :id="item.YMD" style="vertical-align:top;">
                                <table class="border-collapse calendar" style="width:1200px; margin-right:10px;">
                                    <tr>
                                        <th
                                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                            :style="
                                                item.YMD == now_day
                                                    ? 'background-color:#439798 !important; color:#fff;margin-right:10px !important;z-index:999 !importan;'
                                                    : 'border:1px solid #dae1e7;background-color:#f1f1f1 !important;margin-right:10px !important;z-index:999 !importan;'
                                            "
                                            width="430"
                                        >
                                            입원예정<br />{{ item.YMD }} ({{ dayReturn2(item.YMD) }})<br />{{ returnType1(item.YMD, item.RESERVATION_DATA).length }}명
                                        </th>
                                        <th
                                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                            :style="
                                                item.YMD == now_day
                                                    ? 'background-color:#439798 !important; color:#fff;margin-right:10px !important;z-index:999 !importan;'
                                                    : 'border:1px solid #dae1e7;background-color:#f1f1f1 !important;margin-right:10px !important;z-index:999 !importan;'
                                            "
                                            width="430"
                                        >
                                            퇴원예정<br />{{ item.YMD }} ({{ dayReturn2(item.YMD) }})<br />{{ returnType2(item.YMD, item.RESERVATION_DATA).length }}명
                                        </th>
                                        <th
                                            class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                                            :style="
                                                item.YMD == now_day
                                                    ? 'background-color:#439798 !important; color:#fff;margin-right:10px !important;z-index:999 !importan;'
                                                    : 'border:1px solid #dae1e7;background-color:#f1f1f1 !important;margin-right:10px !important;z-index:999 !importan;'
                                            "
                                            width="430"
                                        >
                                            외래<br />{{ item.YMD }} ({{ dayReturn2(item.YMD) }})<br />{{ returnType3(item.YMD, item.RESERVATION_DATA).length }}명
                                        </th>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align:top;">
                                            <!-- 입원예정 시작 -->
                                            <div v-for="(item2, index2) in returnType1(item.YMD, item.RESERVATION_DATA)" :key="index2" class="reservation_div" style="text-align:center;">
                                                <table width="100%" class="border border-solid">
                                                    <colgroup>
                                                        <col width="25%" />
                                                        <col width="35%" />
                                                        <col width="23%" />
                                                        <col width="17%" />
                                                    </colgroup>
                                                    <tr>
                                                        <template v-if="item2.NEW_RE == '신입'">
                                                            <td class="new_bg">{{ item2.NEW_RE }}{{ item2.ORDER_NEWRE }}</td>
                                                            <td class="header_bg new_bg">
                                                                {{ item2.PATIENT_USERNAME }}({{ item2.CHART_NO }} / {{ ageReturn(item2.PATIENT_BIRTHDAY) }}, {{ genderReturn(item2.PATIENT_GENDER) }})
                                                            </td>
                                                            <td class="header_bg new_bg" colspan="2">{{ item2.PATIENT_BIRTHDAY }}</td>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item2.NEW_RE == '재입'">
                                                                <td class="re_bg">{{ item2.NEW_RE }}</td>
                                                                <td class="header_bg">
                                                                    {{ item2.PATIENT_USERNAME }}({{ item2.CHART_NO }} / {{ ageReturn(item2.PATIENT_BIRTHDAY) }},
                                                                    {{ genderReturn(item2.PATIENT_GENDER) }})
                                                                </td>
                                                                <td class="header_bg" colspan="2">{{ item2.PATIENT_BIRTHDAY }}</td>
                                                            </template>
                                                            <template v-else>
                                                                <td class="header_bg">{{ item2.NEW_RE }}</td>
                                                                <td class="header_bg">
                                                                    {{ item2.PATIENT_USERNAME }}({{ item2.CHART_NO }} / {{ ageReturn(item2.PATIENT_BIRTHDAY) }},
                                                                    {{ genderReturn(item2.PATIENT_GENDER) }})
                                                                </td>
                                                                <td class="header_bg" colspan="2">{{ item2.PATIENT_BIRTHDAY }}</td>
                                                            </template>
                                                        </template>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">진단명</td>
                                                        <td>{{ item2.SICKNESS }}</td>
                                                        <td class="th_bg">본병원</td>
                                                        <td>{{ item2.MEDICAL_NAME }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">주치의</td>
                                                        <td>{{ item2.MEDICAL_MEMBER_NAME }}</td>
                                                        <td class="th_bg">협진의</td>
                                                        <td>{{ item2.WEST_MEDICAL_NAME }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">호실</td>
                                                        <td>{{ item2.MEDICAL_ROOM_NUMBER_NM }}(#{{ item2.MEDICAL_CNT }})</td>
                                                        <td class="th_bg">코로나검사</td>
                                                        <td>
                                                            {{ item2.CORONA }}
                                                            <!-- <template v-if="item2.CORONA == 1">완료</template>
                                                            <template v-if="item2.CORONA == 2">선별</template>
                                                            <template v-if="item2.CORONA == 3">간편</template>
                                                            <template v-if="item2.CORONA == 4">PCR</template>
                                                            <template v-if="item2.CORONA == 5">해당없음</template> -->
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">입원예정시간</td>
                                                        <td>{{ item2.IN_TIME.substring(0, 2) }} : {{ item2.IN_TIME.substring(2, 4) }}</td>
                                                        <td style="background-color:#ffff;"></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">입원일 식이</td>
                                                        <td>{{ item2.MEAL_TIME }} / {{ item2.MEAL_NAME }}</td>
                                                        <td class="th_bg">식이비고</td>
                                                        <td>{{ item2.MEAL_MEMO }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">연락처</td>
                                                        <td>{{ item2.PATIENT_PHONE }}</td>
                                                        <td class="th_bg">보호자연락처</td>
                                                        <td>{{ item2.PROTECTOR_PHONE }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">치료플랜</td>
                                                        <td colspan="3">{{ item2.PLAN }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">기타사항</td>
                                                        <td colspan="3">{{ item2.MEMO }}</td>
                                                    </tr>

                                                    <tr>
                                                        <td colspan="4" style="background-color:#fff;">
                                                            <!-- <vx-tooltip text="상세보기" position="top">
                                                                <vs-button color="success" size="samll" type="line" icon-pack="feather" icon="icon-search" @click="memberReport(item2.PATIENT_UID)" />
                                                            </vx-tooltip> -->
                                                            <vs-row vs-type="flex" vs-justify="center">
                                                                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                                                                    <!-- <vx-tooltip text="상세보기" position="top"> -->
                                                                    <vs-button
                                                                        color="success"
                                                                        size="samll"
                                                                        type="line"
                                                                        icon-pack="feather"
                                                                        icon="icon-search"
                                                                        @click="memberReport(item2.PATIENT_UID)"
                                                                    />
                                                                    <!-- </vx-tooltip> -->
                                                                    <!-- <vx-tooltip text="수정" position="top"> -->
                                                                    <vs-button
                                                                        color="primary"
                                                                        size="samll"
                                                                        type="line"
                                                                        icon-pack="feather"
                                                                        icon="icon-edit-2"
                                                                        @click="onClickModifyView(item2.PATIENT_UID)"
                                                                    />
                                                                    <!-- </vx-tooltip> -->
                                                                </vs-col>
                                                            </vs-row>
                                                        </td>
                                                    </tr>
                                                </table>

                                                <hr />
                                            </div>
                                            <!-- 입원예정 끝 -->
                                        </td>
                                        <td style="vertical-align:top;">
                                            <!-- 퇴원예정 시작 -->
                                            <div v-for="(item2, index2) in returnType2(item.YMD, item.RESERVATION_DATA)" :key="index2" class="reservation_div" style="text-align:center;">
                                                <table width="100%" class="border border-solid">
                                                    <colgroup>
                                                        <col width="15%" />
                                                        <col width="35%" />
                                                        <col width="20%" />
                                                        <col width="30%" />
                                                    </colgroup>
                                                    <tr>
                                                        <template v-if="item2.NEW_RE == '신입'">
                                                            <td class="new_bg">{{ item2.NEW_RE }}</td>
                                                            <td class="header_bg new_bg" colspan="2">
                                                                {{ item2.PATIENT_USERNAME }}({{ item2.CHART_NO }} / {{ ageReturn(item2.PATIENT_BIRTHDAY) }}, {{ genderReturn(item2.PATIENT_GENDER) }})
                                                            </td>
                                                            <td class="header_bg new_bg">{{ item2.PATIENT_BIRTHDAY }}</td>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item2.NEW_RE == '재입'">
                                                                <td class="re_bg">{{ item2.NEW_RE }}</td>
                                                                <td class="header_bg" colspan="2">
                                                                    {{ item2.PATIENT_USERNAME }}({{ item2.CHART_NO }} / {{ ageReturn(item2.PATIENT_BIRTHDAY) }},
                                                                    {{ genderReturn(item2.PATIENT_GENDER) }})
                                                                </td>
                                                                <td class="header_bg">{{ item2.PATIENT_BIRTHDAY }}</td>
                                                            </template>
                                                            <template v-else>
                                                                <td class="header_bg">{{ item2.NEW_RE }}</td>
                                                                <td class="header_bg" colspan="2">
                                                                    {{ item2.PATIENT_USERNAME }}({{ item2.CHART_NO }} / {{ ageReturn(item2.PATIENT_BIRTHDAY) }},
                                                                    {{ genderReturn(item2.PATIENT_GENDER) }})
                                                                </td>
                                                                <td class="header_bg">{{ item2.PATIENT_BIRTHDAY }}</td>
                                                            </template>
                                                        </template>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">진단명</td>
                                                        <td>{{ item2.SICKNESS }}</td>
                                                        <td class="th_bg">본병원</td>
                                                        <td>{{ item2.MEDICAL_NAME }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">주치의</td>
                                                        <td>{{ item2.MEDICAL_MEMBER_NAME }}</td>
                                                        <td class="th_bg">협진의</td>
                                                        <td>{{ item2.WEST_MEDICAL_NAME }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">호실</td>
                                                        <td>{{ item2.MEDICAL_ROOM_NUMBER_NM }}(#{{ item2.MEDICAL_CNT }})</td>
                                                        <td class="th_bg">코로나검사</td>
                                                        <td>
                                                            {{ item2.CORONA }}
                                                            <!-- <template v-if="item2.CORONA == 1">완료</template>
                                                            <template v-if="item2.CORONA == 2">선별</template>
                                                            <template v-if="item2.CORONA == 3">간편</template>
                                                            <template v-if="item2.CORONA == 4">PCR</template>
                                                            <template v-if="item2.CORONA == 5">해당없음</template> -->
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">퇴원시간</td>
                                                        <td colspan="3">{{ item2.OUT_TIME.substring(0, 2) }} : {{ item2.OUT_TIME.substring(2, 4) }}</td>
                                                        <!-- <td class="th_bg">식사구분</td>
                                                        <td>{{ item2.MEAL_TIME }}</td> -->
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">재입일정</td>
                                                        <td colspan="3">
                                                            <template v-if="item2.COMPLATE_YN == 'Y'">
                                                                왼퇴
                                                            </template>
                                                            <template v-else>
                                                                {{ item2.IN_DATE }}
                                                            </template>
                                                        </td>
                                                    </tr>
                                                    <!-- <tr>
                                                        <td class="th_bg">입원일 식이</td>
                                                        <td>{{ item2.MEAL_NAME }}</td>
                                                        <td class="th_bg">입원일 식이비고</td>
                                                        <td>{{ item2.MEAL_MEMO }}</td>
                                                    </tr> -->
                                                    <tr>
                                                        <td class="th_bg">연락처</td>
                                                        <td>{{ item2.PATIENT_PHONE }}</td>
                                                        <td class="th_bg">보호자연락처</td>
                                                        <td>{{ item2.PROTECTOR_PHONE }}</td>
                                                    </tr>
                                                    <!-- <tr>
                                                        <td class="th_bg">치료플랜</td>
                                                        <td colspan="3">{{ item2.PLAN }}</td>
                                                    </tr> -->
                                                    <tr class="hs-2" style="">
                                                        <td class="th_bg">비고</td>
                                                        <td colspan="3">{{ item2.MEMO }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="4" style="background-color:#fff;">
                                                            <vs-row vs-type="flex" vs-justify="center">
                                                                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                                                                    <!-- <vx-tooltip text="상세보기" position="top"> -->
                                                                    <vs-button
                                                                        color="success"
                                                                        size="samll"
                                                                        type="line"
                                                                        icon-pack="feather"
                                                                        icon="icon-search"
                                                                        @click="memberReport(item2.PATIENT_UID)"
                                                                    />
                                                                    <!-- </vx-tooltip> -->
                                                                    <!-- <vx-tooltip text="수정" position="top"> -->
                                                                    <vs-button
                                                                        color="primary"
                                                                        size="samll"
                                                                        type="line"
                                                                        icon-pack="feather"
                                                                        icon="icon-edit-2"
                                                                        @click="onClickModifyView(item2.PATIENT_UID)"
                                                                    />
                                                                    <!-- </vx-tooltip> -->
                                                                </vs-col>
                                                            </vs-row>
                                                        </td>
                                                    </tr>
                                                </table>

                                                <hr />
                                            </div>
                                            <!-- 퇴원예정 끝 -->
                                        </td>
                                        <td style="vertical-align:top;">
                                            <!-- 외래 시작 -->
                                            <div v-for="(item2, index2) in returnType3(item.YMD, item.RESERVATION_DATA)" :key="index2" class="reservation_div" style="text-align:center;">
                                                <table width="100%" class="border border-solid">
                                                    <colgroup>
                                                        <col width="20%" />
                                                        <col width="30%" />
                                                        <col width="23%" />
                                                        <col width="27%" />
                                                    </colgroup>
                                                    <tr>
                                                        <template v-if="item2.NEW_RE == '신입'">
                                                            <td class="new_bg">{{ item2.NEW_RE }}</td>
                                                            <td class="header_bg new_bg" colspan="2">
                                                                {{ item2.PATIENT_USERNAME }}({{ item2.CHART_NO }} / {{ ageReturn(item2.PATIENT_BIRTHDAY) }}, {{ genderReturn(item2.PATIENT_GENDER) }})
                                                            </td>
                                                            <td class="header_bg new_bg">{{ item2.PATIENT_BIRTHDAY }}</td>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item2.NEW_RE == '재입'">
                                                                <td class="re_bg">{{ item2.NEW_RE }}</td>
                                                                <td class="header_bg" colspan="2">
                                                                    {{ item2.PATIENT_USERNAME }}({{ item2.CHART_NO }} / {{ ageReturn(item2.PATIENT_BIRTHDAY) }},
                                                                    {{ genderReturn(item2.PATIENT_GENDER) }})
                                                                </td>
                                                                <td class="header_bg">{{ item2.PATIENT_BIRTHDAY }}</td>
                                                            </template>
                                                            <template v-else>
                                                                <td class="header_bg">{{ item2.NEW_RE }}</td>
                                                                <td class="header_bg" colspan="2">
                                                                    {{ item2.PATIENT_USERNAME }}({{ item2.CHART_NO }} / {{ ageReturn(item2.PATIENT_BIRTHDAY) }},
                                                                    {{ genderReturn(item2.PATIENT_GENDER) }})
                                                                </td>
                                                                <td class="header_bg">{{ item2.PATIENT_BIRTHDAY }}</td>
                                                            </template>
                                                        </template>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">진단명</td>
                                                        <td>{{ item2.SICKNESS }}</td>
                                                        <td class="th_bg">본병원</td>
                                                        <td>{{ item2.MEDICAL_NAME }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">주치의</td>
                                                        <td>{{ item2.MEDICAL_MEMBER_NAME }}</td>
                                                        <td class="th_bg">협진의</td>
                                                        <td>{{ item2.WEST_MEDICAL_NAME }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">치료내용</td>
                                                        <td colspan="3">{{ item2.MEDICAL_ROOM_NUMBER_NM }}</td>
                                                    </tr>

                                                    <tr class="hs-2">
                                                        <td class="th_bg">메모</td>
                                                        <td colspan="3">{{ item2.MEMO }}</td>
                                                    </tr>
                                                    <!-- <tr>
                                                        <td class="th_bg">호실</td>
                                                        <td>{{ item2.MEDICAL_ROOM_NUMBER_NM }}</td>
                                                        <td class="th_bg">코로나검사</td>
                                                        <td>
                                                            {{ item2.CORONA }}
                                                            
                                                        </td>
                                                    </tr> -->
                                                    <!-- <tr>
                                                        <td class="th_bg">입원예정시간</td>
                                                        <td>{{ item2.IN_TIME.substring(0, 2) }} : {{ item2.IN_TIME.substring(2, 4) }}</td>
                                                        <td class="th_bg">식사구분</td>
                                                        <td>{{ item2.MEAL_TIME }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="th_bg">입원일 식이</td>
                                                        <td>{{ item2.MEAL_NAME }}</td>
                                                        <td class="th_bg">입원일 식이비고</td>
                                                        <td>{{ item2.MEAL_MEMO }}</td>
                                                    </tr> -->
                                                    <tr>
                                                        <td class="th_bg">연락처</td>
                                                        <td>{{ item2.PATIENT_PHONE }}</td>
                                                        <td class="th_bg">보호자연락처</td>
                                                        <td>{{ item2.PROTECTOR_PHONE }}</td>
                                                    </tr>
                                                    <tr class="hs-2">
                                                        <td class="th_bg">치료플랜</td>
                                                        <td colspan="3">{{ item2.PLAN }}</td>
                                                    </tr>

                                                    <tr>
                                                        <td colspan="4" style="background-color:#fff;">
                                                            <!-- <vx-tooltip text="상세보기" position="top">
                                                                <vs-button color="success" size="samll" type="line" icon-pack="feather" icon="icon-search" @click="memberReport(item2.PATIENT_UID)" />
                                                            </vx-tooltip> -->
                                                            <vs-row vs-type="flex" vs-justify="center">
                                                                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                                                                    <!-- <vx-tooltip text="상세보기" position="top"> -->
                                                                    <vs-button
                                                                        color="success"
                                                                        size="samll"
                                                                        type="line"
                                                                        icon-pack="feather"
                                                                        icon="icon-search"
                                                                        @click="memberReport(item2.PATIENT_UID)"
                                                                    />
                                                                    <!-- </vx-tooltip> -->
                                                                    <!-- <vx-tooltip text="수정" position="top"> -->
                                                                    <vs-button
                                                                        color="primary"
                                                                        size="samll"
                                                                        type="line"
                                                                        icon-pack="feather"
                                                                        icon="icon-edit-2"
                                                                        @click="onClickModifyView(item2.PATIENT_UID)"
                                                                    />
                                                                    <!-- </vx-tooltip> -->
                                                                </vs-col>
                                                            </vs-row>
                                                        </td>
                                                    </tr>
                                                </table>

                                                <hr />
                                            </div>
                                            <!-- 외래 끝 -->
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tbody>
                    </table>
                </div>
            </div>
        </vx-card>
        <!-- 차트보기 팝업 시작 -->
        <vs-popup title="차트보기" :active.sync="popupActive">
            <div class="vx-row">
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <vx-card class="p-2">
                        <div class="text-center">
                            <p class="text-grey">#{{ chart_no }}</p>
                            <h4>{{ patientUsername }}({{ status_name }})</h4>
                            <p class="text-grey">{{ patientAge }}, {{ patientGender }}</p>
                            <p class="text-grey">{{ patient_phone }}</p>
                        </div>
                        <vs-divider></vs-divider>
                        <!-- <vs-avatar class="mx-auto my-6 block" size="80px" /> -->
                        <div class="flex justify-between text-center">
                            <span>
                                <p class="font-semibold">{{ medicalRoomNm }}({{ medicalRoomNumberNm }})</p>
                                <small class="text-grey">병동(호실)</small>
                            </span>
                            <span>
                                <p class="font-semibold">{{ medicalName }}</p>
                                <small class="text-grey">본 병원</small>
                            </span>
                            <span>
                                <p class="font-semibold">{{ sickNess }}</p>
                                <small class="text-grey">병명</small>
                            </span>
                        </div>
                        <vs-divider></vs-divider>
                        <div class="my-6">
                            <h5 class="mb-2">치료플랜</h5>
                            <p class="plan_text">
                                <template v-if="plan == null || plan == 0">작성한 치료플랜 없음</template>
                                <template v-else>{{ plan }}</template>
                            </p>
                        </div>
                        <vs-divider></vs-divider>
                        <table style="width:100%;" class="border-collapse calendar">
                            <colgroup>
                                <col width="40%" />
                                <col width="60%" />
                            </colgroup>

                            <tbody>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">최초입원일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ in_init_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">입원일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ in_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">퇴원예정일</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ out_date }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">왼퇴여부</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ complate_yn }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">식이</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ meal_name }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">보호자</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ protector_phone }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">주치의</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ medical_nm }}</td>
                                </tr>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">협진의</th>
                                    <td class="border border-solid d-theme-border-grey-light">{{ west_medical_nm }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <div class="my-6">
                            <h5 class="mb-2">컴플레인</h5>
                            <vs-textarea placeholder="자유롭게 작성 후 저장버튼 클릭." height="200px" v-model="memo" />
                        </div> -->

                        <!-- <vs-button type="gradient" class="w-full mt-6" color="#7367F0" gradient-color-secondary="#CE9FFC" @click="patientMemoSave">저장</vs-button> -->
                    </vx-card>
                </div>
            </div>
        </vs-popup>
        <!-- 차트보기 팝업 끝 -->
        <!-- 환자 수정 팝업 시작 -->
        <vs-popup title="환자 수정" :active.sync="openPopup1">
            <form @submit.prevent>
                <!-- 20210528 HP추가-->
                <div class="vx-row mb-3">
                    <vs-button type="line" :class="activeMenu2(1)" @click="popTabClick(1)">환자관리</vs-button>
                    <vs-button type="line" :class="activeMenu2(2)" @click="popTabClick(2)" v-show="tab_sum & 1024">상담내역</vs-button>
                </div>
                <!-- 20210528 HP추가-->
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-input type="number" v-validate="'required'" class="w-full" name="chartNo" v-model="chartNo" label="차트번호" placeholder="ex) 123" />
                        <span class="text-danger text-sm" v-show="errors.has('chartNo')">차트번호 입력해주세요</span>
                    </div>
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-input maxlength="10" v-validate="'required'" class="w-full" name="patientUsername" v-model="patientUsername" label="이름" placeholder="ex) 홍길동" />
                        <span class="text-danger text-sm" v-show="errors.has('patientUsername')">이름을 입력해주세요</span>
                    </div>
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-input
                            maxlength="14"
                            v-validate="'required'"
                            class="w-full"
                            name="jumin"
                            v-model="jumin"
                            label="주민번호 (-)포함"
                            placeholder="ex) 801203-1******"
                            @blur="juminCheck"
                            :id="'jumin'"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('jumin')">주민번호 입력</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/3 ">
                        <label for="" class="vs-input--label">생년월일</label>
                        <date-picker disabled name="patientBirthday" v-model="patientBirthday" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker>
                    </div>
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-select disabled autocomplete class="w-auto" name="patientGender" v-model="patientGender" label="성별" placeholder="ex) 남자">
                            <vs-select-item value="M" text="남자" />
                            <vs-select-item value="F" text="여자" />
                        </vs-select>
                    </div>
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-input disabled type="number" class="w-full" name="age" v-model="age" label="나이" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-input maxlength="15" class="w-full" name="patientPhone" v-model="patientPhone" label="연락처" placeholder="ex) 010-1234-1234" />
                    </div>
                    <div class="vx-col w-full lg:w-2/3">
                        <vs-select autocomplete class="w-auto" name="address" v-model="address" label="주소지" placeholder="ex) 마포구(구단위까지)">
                            <div :key="index" v-for="(item, index) in addrOptions">
                                <vs-select-group :title="item.title" v-if="item.group">
                                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in item.group" />
                                </vs-select-group>
                            </div>
                        </vs-select>
                    </div>
                </div>
                <!--예진기록시작-->
                <vx-card ref="" title="예진기록" class="user-list-filters mb-8" collapseAction :isCollapsed="false">
                    <div class="vx-row mb-3">
                        <div :class="sickNess != '직접입력' ? 'vx-col w-full lg:w-1/3' : 'vx-col w-full lg:w-1/3'">
                            <vs-select autocomplete class="w-auto" name="sickNess" v-model="sickNess" label="진단명" placeholder="ex) 위암">
                                <vs-select-item :value="item.SICKNESS" :text="item.SICKNESS" v-for="(item, index) in sickNessList" :key="index" />
                                <vs-select-item value="직접입력" text="직접입력" />
                            </vs-select>
                        </div>
                        <div class="vx-col w-full lg:w-1/3" v-show="sickNess == '직접입력'">
                            <vs-input maxlength="15" class="w-full" name="sickNessText" v-model="sickNessText" label="진단명" placeholder="ex) 위암" />
                        </div>
                        <div class="vx-col w-full lg:w-1/3">
                            <vs-select autocomplete class="w-auto" name="bodyPart" v-model="bodyPart" label="부위" placeholder="ex) Lt">
                                <vs-select-item :value="item.BODYPART" :text="item.BODYPART" v-for="(item, index) in bodyPartList" :key="index" />
                            </vs-select>
                        </div>
                        <div class="vx-col w-full lg:w-1/3">
                            <vs-input maxlength="5" class="w-full" name="gisu" v-model="gisu" label="기수" placeholder="ex) 3기" />
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <!-- <div class="vx-col w-full lg:w-1/3">
                            <vs-select autocomplete class="w-auto" name="bodyPart" v-model="bodyPart" label="부위" placeholder="ex) Lt">
                                <vs-select-item :value="item.BODYPART" :text="item.BODYPART" v-for="(item, index) in bodyPartList" :key="index" />
                            </vs-select>
                        </div> -->
                        <div class="vx-col w-full lg:w-1/3 ">
                            <label for="" class="vs-input--label">진단일</label>
                            <date-picker name="diagnosisDate" v-model="diagnosisDate" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker>
                        </div>
                        <div class="vx-col w-full lg:w-1/3 ">
                            <label for="" class="vs-input--label">수술일</label>
                            <date-picker name="operationDate" v-model="operationDate" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full lg:w-1/3 ">
                            <vs-select autocomplete class="w-auto" name="metastasisYn" v-model="metastasisYn" label="전이여부" placeholder="ex) 유/무">
                                <vs-select-item :value="'Y'" :text="'유'" />
                                <vs-select-item :value="'N'" :text="'무'" />
                            </vs-select>
                        </div>
                        <div class="vx-col w-full lg:w-2/3 " v-show="metastasisYn == 'Y'">
                            <vs-input class="w-full" name="metastasisPart" v-model="metastasisPart" label="전이부위" placeholder="ex) 전이부위 작성" />
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full lg:w-1/3 ">
                            <label for="" class="vs-input--label">항암치료</label>
                            <date-picker name="anticancerDate" v-model="anticancerDate" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker>
                        </div>
                        <div class="vx-col w-full lg:w-1/3 ">
                            <label for="" class="vs-input--label">방사선치료</label>
                            <date-picker name="radiotherapyDate" v-model="radiotherapyDate" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full lg:w-1/3 ">
                            <vs-select autocomplete class="w-auto" name="antiagentYn" v-model="antiagentYn" label="항암제" placeholder="ex) 유/무">
                                <vs-select-item :value="'Y'" :text="'유'" />
                                <vs-select-item :value="'N'" :text="'무'" />
                            </vs-select>
                        </div>
                        <div class="vx-col w-full lg:w-2/3 " v-show="antiagentYn == 'Y'">
                            <vs-input class="w-full" name="antiagent" v-model="antiagent" label="약명" placeholder="ex) 약명 작성" />
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full lg:w-1/3 ">
                            <vs-select autocomplete class="w-auto" name="anamnesisYn" v-model="anamnesisYn" label="기왕력" placeholder="ex) 유/무">
                                <vs-select-item :value="'Y'" :text="'유'" />
                                <vs-select-item :value="'N'" :text="'무'" />
                            </vs-select>
                        </div>
                        <div class="vx-col w-full lg:w-2/3 " v-show="anamnesisYn == 'Y'">
                            <template>
                                <ul class="centerx">
                                    <label for="" class="vs-select--label">기왕력 상세</label>
                                    <li v-for="(item, index) in anamnesisList" :key="index">
                                        <vs-checkbox v-model="anamnesis" :vs-value="item.ANAMNESIS" @input="anamnesisInput">{{ item.ANAMNESIS }}</vs-checkbox>
                                        <vs-input
                                            :disabled="anamnesis.indexOf('기타') < 0"
                                            class="w-full"
                                            name="anamnesisEtc"
                                            v-model="anamnesisEtc"
                                            placeholder="ex) 기타 작성"
                                            v-if="item.ANAMNESIS == '기타'"
                                        />
                                    </li>
                                </ul>
                            </template>
                        </div>
                    </div>
                </vx-card>
                <!--예진기록끝-->
                <div class="vx-row mb-3">
                    <div :class="medicalName != '직접입력' ? 'vx-col w-full lg:w-2/3' : 'vx-col w-full lg:w-1/3'">
                        <vs-select autocomplete class="w-auto" name="medicalName" v-model="medicalName" label="본병원" placeholder="ex) 세브란스신촌">
                            <vs-select-item value="" text="초기값" />
                            <vs-select-item :value="item.MEDICAL_CENTER_NAME" :text="item.MEDICAL_CENTER_NAME" v-for="(item, index) in medicalCenterList" :key="index" />
                            <vs-select-item value="직접입력" text="직접입력" />
                        </vs-select>
                    </div>
                    <div class="vx-col w-full lg:w-2/3" v-show="medicalName == '직접입력'">
                        <vs-input maxlength="15" class="w-full" name="medicalNameText" v-model="medicalNameText" label="본병원" placeholder="ex) 세브란스신촌" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/3 ">
                        <vs-select autocomplete class="w-auto" name="protector" v-model="protector" label="보호자관계" placeholder="ex) 딸">
                            <vs-select-item value="" text="초기값" />
                            <vs-select-item :value="item.PROTECTOR" :text="item.PROTECTOR" v-for="(item, index) in protectorList" :key="index" />
                        </vs-select>
                    </div>
                    <div class="vx-col w-full lg:w-2/3">
                        <vs-input maxlength="20" class="w-full" name="protectorPhone" v-model="protectorPhone" label="보호자연락처" placeholder="ex) 010-1234-1234" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-input class="w-full" name="newRe" v-model="newRe" label="신입재입" placeholder="(자동기입이니 공란으로)" maxlength="5" disabled />
                    </div>
                    <div :class="cdStatus != '' && cdStatus != 6 && cdStatus != 9 && cdStatus != 11 && cdStatus != 12 && cdStatus != 13 ? 'vx-col w-full lg:w-1/3' : 'vx-col w-full lg:w-2/3'">
                        <template>
                            <vs-select v-validate="'required'" autocomplete class="w-auto" name="cdStatus" v-model="cdStatus" label="현재상태" placeholder="현재상태 선택" @input="cdStatusChange()">
                                <vs-select-item :value="item.CD_STATUS" :text="item.STATUS_NAME" v-for="(item, index) in statusList" :key="index" />
                            </vs-select>
                        </template>

                        <span class="text-danger text-sm" v-show="errors.has('cdStatus')">현재상태 선택해주세요</span>
                    </div>

                    <div class="vx-col w-full lg:w-1/3" v-show="cdStatus != '' && cdStatus != 6 && cdStatus != 9 && cdStatus != 11 && cdStatus != 12 && cdStatus != 13">
                        <vs-select v-validate="'required'" autocomplete class="w-auto" name="medicalRoomNumberNmEtc" v-model="medicalRoomNumberNm" label="세부 선택" placeholder="현재상태 세부 선택">
                            <vs-select-item
                                :value="item2.MEDICAL_ROOM_NUMBER_NM"
                                :text="item2.MEDICAL_ROOM_NM + ' - ' + item2.MEDICAL_ROOM_NUMBER_NM"
                                v-for="(item2, index2) in medicalRoomNumberListEtc"
                                :key="index2"
                            />
                        </vs-select>
                        <span class="text-danger text-sm" v-show="errors.has('medicalRoomNumberNmEtc')">세부 선택해주세요.</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/3 ">
                        <label for="" class="vs-input--label">최초입원일</label>
                        <date-picker
                            name="inInitDate"
                            v-model="inInitDate"
                            :locale="'ko'"
                            valueType="format"
                            class="vs-inputx normal w-full"
                            @input="statusCheck(completeYn, inInitDate, inDate, outDate)"
                        ></date-picker>
                    </div>
                    <div class="vx-col w-full lg:w-1/3 ">
                        <label for="" class="vs-input--label">입원예정일</label>
                        <date-picker
                            name="inDate"
                            v-model="inDate"
                            :locale="'ko'"
                            valueType="format"
                            class="vs-inputx normal w-full"
                            @input="[statusCheck(completeYn, inInitDate, inDate, outDate), inTimeReset()]"
                        ></date-picker>
                    </div>
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-input minlength="4" maxlength="4" class="w-full" name="inTime" v-model="inTime" label="입원예정시간(hhmm)" placeholder="오후2시 30분 = 1430" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/3 ">
                        <label for="" class="vs-input--label">퇴원예정일</label>
                        <date-picker
                            name="outDate"
                            v-model="outDate"
                            :locale="'ko'"
                            valueType="format"
                            class="vs-inputx normal w-full"
                            @input="statusCheck(completeYn, inInitDate, inDate, outDate)"
                        ></date-picker>
                    </div>
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-input minlength="4" maxlength="4" class="w-full" name="outTime" v-model="outTime" label="퇴원예정시간(hhmm)" placeholder="오전 11시 30분 = 1130" />
                    </div>
                    <div class="vx-col w-full lg:w-1/3 ">
                        <vs-select
                            autocomplete
                            class="w-auto"
                            name="completeYn"
                            v-model="completeYn"
                            label="완퇴여부"
                            placeholder="ex) Y"
                            @input="statusCheck(completeYn, inInitDate, inDate, outDate)"
                        >
                            <vs-select-item value="Y" text="Y" />
                            <vs-select-item value="N" text="N" />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-select autocomplete class="w-auto" name="mealTime" v-model="mealTime" label="식사구분" placeholder="ex) 아침">
                            <vs-select-item value="" text="초기값" />
                            <vs-select-item :value="item.MEALTIME_NM" :text="item.MEALTIME_NM" v-for="(item, index) in mealTimeList" :key="index" />
                        </vs-select>
                    </div>
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-select autocomplete class="w-auto" name="mealName" v-model="mealName" label="입원일 식이" placeholder="ex) 일반식 현미밥">
                            <vs-select-item value="" text="초기값" />
                            <vs-select-item :value="item.MEALNAME" :text="item.MEALNAME" v-for="(item, index) in mealNameList" :key="index" />
                        </vs-select>
                    </div>
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-select autocomplete class="w-auto" name="mealMemo" v-model="mealMemo" label="입원일 식이 비고" placeholder="ex) 밥추가, 보호자식">
                            <vs-select-item value="" text="초기값" />
                            <vs-select-item :value="item.MEALMEMO" :text="item.MEALMEMO" v-for="(item, index) in mealMemoList" :key="index" />
                            <vs-select-item value="직접입력" text="직접입력" />
                        </vs-select>
                    </div>
                </div>
                <div class="pt-2 pb-2">
                    기준식이
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-select autocomplete class="w-auto" name="breakfast_mealName" v-model="breakfast_mealName" label="아침" placeholder="ex) 일반식 현미밥">
                            <vs-select-item value="" text="초기값" />
                            <vs-select-item :value="item.MEALNAME" :text="item.MEALNAME" v-for="(item, index) in mealNameList" :key="index" />
                        </vs-select>
                    </div>
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-select autocomplete class="w-auto" name="lunch_mealName" v-model="lunch_mealName" label="점심" placeholder="ex) 일반식 현미밥">
                            <vs-select-item value="" text="초기값" />
                            <vs-select-item :value="item.MEALNAME" :text="item.MEALNAME" v-for="(item, index) in mealNameList" :key="index" />
                        </vs-select>
                    </div>
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-select autocomplete class="w-auto" name="dinner_mealName" v-model="dinner_mealName" label="저녁" placeholder="ex) 일반식 현미밥">
                            <vs-select-item value="" text="초기값" />
                            <vs-select-item :value="item.MEALNAME" :text="item.MEALNAME" v-for="(item, index) in mealNameList" :key="index" />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-row mb-3" v-show="mealMemo == '직접입력'">
                    <div class="vx-col w-full lg:w-3/3">
                        <vs-input maxlength="15" class="w-full" name="mealMemoText" v-model="mealMemoText" label="입원일 식이 비고" placeholder="ex) 밥추가, 보호자식" />
                    </div>
                </div>
                <div class="vx-row mb-3" v-show="cdStatus == 6 || cdStatus == 9 || cdStatus == 11 || cdStatus == 12 || cdStatus == 13">
                    <div class="vx-col w-full lg:w-1/3 ">
                        <vs-select autocomplete class="w-auto" name="medicalRoomNm" v-model="medicalRoomNm" label="병동선택" placeholder="ex) 2병동" @input="medicalRoomChange()">
                            <vs-select-item value="" text="초기값" />
                            <vs-select-item :value="item2.MEDICAL_ROOM_NM" :text="item2.MEDICAL_ROOM_NM" v-for="(item2, index2) in medicalRoomList" :key="index2" />
                        </vs-select>
                    </div>
                    <div class="vx-col w-full lg:w-1/3 ">
                        <vs-select
                            v-validate="'required'"
                            autocomplete
                            class="w-auto"
                            name="medicalRoomNumberNm"
                            v-model="medicalRoomNumberNm"
                            label="병실선택"
                            placeholder="ex) 201호"
                            @input="medicalRoomNumberChange()"
                        >
                            <vs-select-item value="" text="초기값" />
                            <vs-select-item :value="item2.MEDICAL_ROOM_NUMBER_NM" :text="item2.MEDICAL_ROOM_NUMBER_NM" v-for="(item2, index2) in medicalRoomNumberList2" :key="index2" />
                        </vs-select>
                    </div>
                    <div class="vx-col w-full lg:w-1/3 ">
                        <vs-select autocomplete class="w-auto" name="medicalRoomNumberCnt" v-model="medicalRoomNumberCnt" label="베드위치" placeholder="ex) 1">
                            <vs-select-item :value="String(item2.NEXT_CD)" :text="String(item2.NEXT_CD)" v-for="(item2, index2) in medicalRoomNumberCntList" :key="index2" />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-select v-validate="'required'" autocomplete class="w-auto" name="medical_member_name" v-model="medical_member_name" label="주치의" placeholder="ex) 홍길동">
                            <vs-select-item :value="item.MEDICAL_NM" :text="item.MEDICAL_NM" v-for="(item, index) in medicalMemberList" :key="index" />
                        </vs-select>
                        <span class="text-danger text-sm" v-show="errors.has('medical_member_name')">주치의 선택해주세요</span>
                    </div>
                    <div class="vx-col w-full lg:w-1/3">
                        <vs-select autocomplete class="w-auto" name="westMedicalNm" v-model="westMedicalNm" label="협진의" placeholder="ex) 홍길동">
                            <vs-select-item :value="item.MEDICAL_NM" :text="item.MEDICAL_NM" v-for="(item, index) in medicalMemberList" :key="index" />
                        </vs-select>
                    </div>
                    <div class="vx-col w-full lg:w-1/3 ">
                        <vs-select autocomplete class="w-auto" name="corona" v-model="corona" label="코로나검사여부" placeholder="ex) PCR">
                            <vs-select-item :value="item.CORONA" :text="item.CORONA" v-for="(item, index) in coronaList" :key="index" />
                        </vs-select>
                    </div>
                </div>

                <div class="vx-row mb-3">
                    <div class="vx-col w-full">
                        <vs-input class="w-full" name="plan" v-model="plan" label="치료플랜" placeholder="ex) 상담실 통해 확인 필요" />
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full">
                        <vs-input class="w-full" name="memo" v-model="memo" label="기타사항" placeholder="ex) 1인실 희망" />
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full text-right">
                        <vs-button class="mr-3 mb-2" @click="onClickModify">저장</vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click="onClickModifyHide">닫기</vs-button>
                    </div>
                </div>
            </form>
        </vs-popup>
        <!-- 환자 수정 팝업 끝 -->
        <!--상담내역팝업시작-->
        <vs-popup title="상담내역" :active.sync="csPopup">
            <form>
                <!-- 20210528 HP추가-->
                <div class="vx-row mb-3">
                    <vs-button type="line" :class="activeMenu2(1)" @click="popTabClick(1)">환자관리</vs-button>
                    <vs-button type="line" :class="activeMenu2(2)" @click="popTabClick(2)" v-show="tab_sum & 1024">상담내역</vs-button>
                </div>
                <!-- 20210528 HP추가-->
                <!-- 20210607 HP추가 -->
                <div class="vx-row">
                    <div class="vx-col w-full text-right">
                        <vs-button class="mb-1" color="success" @click="addClickCs">(+)추가</vs-button>
                        <!-- 20210608 HP수정 -->
                        <vs-button class="ml-3" @click="saveClickCs" v-show="csDatas.length > 0">모두 저장</vs-button>
                        <!-- 20210608 HP수정 -->
                    </div>
                </div>
                <!-- 20210607 HP추가 -->
                <vx-card ref="" :title="data.CS_DATE + ' ' + data.CS_TIME" class="user-list-filters mb-8" v-for="(data, data_index) in csDatas" :key="data_index">
                    <!-- 20210607 HP수정-->
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full lg:w-1/3 ">
                            <vs-select autocomplete class="w-auto" name="csPathCode" v-model="data.CS_PATH_CODE" label="경로" placeholder="ex) 전화">
                                <vs-select-item :value="item.CS_PATH_CODE" :text="item.CS_PATH" v-for="(item, index) in csPathList" :key="index" />
                            </vs-select>
                        </div>
                        <div class="vx-col w-full lg:w-1/3 ">
                            <vs-select autocomplete class="w-auto" name="csCateCode" v-model="data.CS_CATE_CODE" label="문의종류" placeholder="ex) 신규">
                                <vs-select-item :value="item.CS_CATE_CODE" :text="item.CS_CATE" v-for="(item, index) in csCateList" :key="index" />
                            </vs-select>
                        </div>
                        <div class="vx-col w-full lg:w-1/3 ">
                            <vs-select autocomplete class="w-auto" name="csMeberCode" v-model="data.CS_MEMBER_CODE" label="담당자" placeholder="ex) 담당자 선택">
                                <vs-select-item :value="item.CS_MEMBER_CODE" :text="item.CS_MEMBER" v-for="(item, index) in csMemberList" :key="index" />
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full lg:w-1/3">
                            <vs-input class="w-full" name="inquirer" v-model="data.INQUIRER" label="문의자" placeholder="ex) 홍길동" />
                        </div>
                        <div class="vx-col w-full lg:w-1/3">
                            <vs-input class="w-full" name="phone" v-model="data.PHONE" label="연락처" placeholder="ex) 010-1234-5678" />
                        </div>
                        <div class="vx-col w-full lg:w-1/3">
                            <vs-input class="w-full" name="relation" v-model="data.RELATION" label="관계" placeholder="ex) 본인" />
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full lg:w-1/3 ">
                            <vs-select autocomplete class="w-auto" name="csFavorCode" v-model="data.CS_FAVOR_CODE" label="호의도" placeholder="ex) 입원예약">
                                <vs-select-item :value="item.CS_FAVOR_CODE" :text="item.CS_FAVOR" v-for="(item, index) in csFavorList" :key="index" />
                            </vs-select>
                        </div>
                        <div class="vx-col w-full lg:w-1/3 ">
                            <label for="" class="vs-input--label">다음일정</label>
                            <date-picker name="nextDate" v-model="data.NEXT_DATE" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker>
                        </div>
                        <div class="vx-col w-full lg:w-1/3 ">
                            <vs-select autocomplete class="w-auto" name="csIssueCode" v-model="data.CS_ISSUE_CODE" label="부정이슈 종류" placeholder="ex) 비용">
                                <vs-select-item :value="item.CS_ISSUE_CODE" :text="item.CS_ISSUE" v-for="(item, index) in csIssueList" :key="index" />
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <label for="" class="vs-input--label">상담내역</label>
                            <vs-textarea name="csContent" v-model="data.CS_CONTENT" />
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full text-right">
                            <vs-button type="border" color="warning" @click="removeClickCs(data_index)"> (-)삭제 </vs-button>
                        </div>
                    </div>
                </vx-card>

                <!-- 20210608 HP수정 -->
                <!-- <div class="vx-row">
                    <div class="vx-col w-full text-right">
                        <vs-button color="success" @click="addClickCs">(+)추가</vs-button>
                        <vs-button class="ml-3" @click="saveClickCs" v-show="csDatas.length > 0">모두 저장</vs-button>
                    </div>
                </div> -->
                <!-- 20210608 HP수정 -->
            </form>
        </vs-popup>
        <!--상담내역팝업끝-->
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import dateClass from '@/../util/dateClass';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import store from '@/store/store';
import { EventBus } from '../../../util/vue-event-bus';
export default {
    components: {
        DatePicker,
    },
    data() {
        return {
            now_date: '',
            prev_date: '',
            next_date: '',
            list: [],
            now_day: '',
            popupActive: false,
            openPopup1: false,
            patientUid: '',
            patientUsername: '',
            patientAge: '',
            patientGender: '',
            medicalRoomNm: '',
            medicalRoomNumberNm: '',
            medicalName: '',
            sickNess: '',
            plan: '',
            memo: '',
            chart_no: '',
            status_name: '',
            patient_phone: '',
            in_init_date: '',
            in_date: '',
            out_date: '',
            complate_yn: '',
            meal_name: '',
            medical_nm: '',
            west_medical_nm: '',
            protector_phone: '',
            gisu: '',
            jumin: '',
            patientBirthday: '',
            age: 0,
            newRe: '',
            cdStatus: '',
            inInitDate: '',
            inDate: '',
            inTime: '',
            outDate: '',
            outTime: '',
            completeYn: 'N',
            mealTime: '',
            mealName: '',
            mealMemo: '',
            breakfast_mealName: '',
            lunch_mealName: '',
            dinner_mealName: '',
            medical_member_name: '',
            westMedicalNm: '',
            patientPhone: '',
            address: '',
            protectorPhone: '',
            protectorYN: 'N',
            medicalNameText: '',
            corona: '',
            medicalMemberList: [],
            medicalCenterList: [],
            statusList: [],
            medicalRoomNumberListEtc: [],
            tab_menu: [],
            medical_room_seq: '',
            juminTF: false,
            medicalRoomList: [],
            medicalRoomNumberList2: [],
            medicalRoomNumberNm_detail: '',
            medicalRoomNumberCntList: [],
            medicalRoomNumberCnt: '',
            sickNessList: [],
            sickNessText: '',
            addressList: [],
            addressText: '',
            protectorList: [],
            protector: '',
            mealTimeList: [],
            mealNameList: [],
            mealMemoList: [],
            mealMemoText: '',
            coronaList: [],
            chartNo: 0,
            addrOptions: [],

            // 20210526 HP 추가
            bodyPartList: [],
            anamnesisList: [],

            bodyPart: '',
            diagnosisDate: '',
            operationDate: '',
            metastasisYn: 'N',
            metastasisPart: '',
            anticancerDate: '',
            radiotherapyDate: '',
            antiagentYn: 'N',
            antiagent: '',
            anamnesisYn: 'N',
            anamnesis: [],
            anamnesisEtc: '',
            // 20210526 HP 추가

            // 20210527 HP 추가
            csPopup: false,
            csPathList: [],
            csCateList: [],
            csMemberList: [],
            csFavorList: [],
            csIssueList: [],
            csDatas: [],
            // 20210527 HP 추가

            // 20210528 HP 추가
            popTabIdx: 1,
            // 20210528 HP 추가
            // 20210607 HP tab_sum
            tab_sum: 0,
            // 20210607 HP tab_sum
            width: window.innerWidth,
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
        },
        async getData(date) {
            this.userUid = store.getters.getUID;

            this.now_day = dateClass.getDate('YYYY-MM-DD');

            if (date == '') {
                this.now_date = dateClass.dateYYYYMM();
            } else {
                this.now_date = date;
            }
            console.log(this.now_date);
            this.prev_date = dateClass.prevYYYYMM(this.now_date.substring(0, 6));
            this.next_date = dateClass.nextYYYYMM(this.now_date.substring(0, 6));

            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });

            let params = {
                userUid: this.userUid,
            };

            const { data } = await axiosClass.get('/api/remote/list/' + this.now_date, params, true);

            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);
            this.list = data.data;
            this.medicalMemberList = data.medicalMemberList;
            this.medicalCenterList = data.medicalCenterList;
            this.sickNessList = data.sickNessList;
            this.addressList = data.addressList;
            this.protectorList = data.protectorList;
            this.mealTimeList = data.mealTimeList;
            this.mealNameList = data.mealNameList;
            this.mealMemoList = data.mealMemoList;
            this.coronaList = data.coronaList;

            if (this.addrOptions.length == 0) {
                let addrOptions_Obj = {};
                addrOptions_Obj.group = [];
                for (let i = 0; i < data.addressList.length; i++) {
                    const obj = data.addressList[i];
                    const _do = obj.DO;
                    const _bf_do = i > 0 ? data.addressList[i - 1].DO : '';
                    const _si = obj.SI;
                    const groupObj = { text: _si, value: _si };
                    if (_do != _bf_do) {
                        if (i > 0) {
                            this.addrOptions.push(addrOptions_Obj);
                        }
                        addrOptions_Obj = {};
                        addrOptions_Obj.group = [];
                        addrOptions_Obj.title = _do;
                    } else {
                        if (data.addressList.length == i + 1) {
                            this.addrOptions.push(addrOptions_Obj);
                        }
                    }
                    addrOptions_Obj.group.push(groupObj);
                }
            }
            this.statusList = data.statusList;

            this.medicalRoomNumberListEtc = data.medicalRoomNumberListEtc;
            this.medicalRoomList = data.medicalRoomList;
            // 20210526 HP 추가
            this.bodyPartList = data.bodyPartList;
            this.anamnesisList = data.anamnesisList;
            // 20210526 HP 추가

            // 20210527 HP 추가
            this.csPathList = data.csPathList;
            this.csCateList = data.csCateList;
            this.csMemberList = data.csMemberList;
            this.csFavorList = data.csFavorList;
            this.csIssueList = data.csIssueList;
            // 20210527 HP 추가

            setTimeout(function() {
                console.log('refresh');

                // location.href = '#' + dateClass.getDate('YYYY-MM-DD');
                var element = document.getElementById(dateClass.getDate('YYYY-MM-DD'));
                // element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
                element.scrollIntoView({ block: 'nearest' });
                console.log(element);
            }, 500);
        },
        ageReturn(birthday) {
            const now_data = moment().format('YYYY');
            if (birthday == '') {
                return '생년월일 없음';
            } else {
                const birthday_year = birthday.split('-');
                return now_data - birthday_year[0];
            }
        },
        genderReturn(gender) {
            if (gender == 'M') {
                return '남';
            } else if (gender == 'F') {
                return '여';
            } else {
                return '지정안함';
            }
        },

        returnType1(ymd, item) {
            let data = [];
            try {
                const json = JSON.parse(item);

                let data = [];
                for (let i = 0; i < json.length; i++) {
                    if (json[i].GUBUN_TYPE == '1') {
                        data.push(json[i]);
                    }
                }

                return data;
            } catch (e) {
                console.log(e.message);
                return [];
            }
        },

        returnType2(ymd, item) {
            let data = [];
            try {
                const json = JSON.parse(item);
                let data = [];
                for (let i = 0; i < json.length; i++) {
                    if (json[i].GUBUN_TYPE == 2) {
                        data.push(json[i]);
                    }
                }

                return data;
            } catch (e) {
                return [];
            }
        },

        returnType3(ymd, item) {
            let data = [];
            try {
                const json = JSON.parse(item);
                let data = [];
                for (let i = 0; i < json.length; i++) {
                    if (json[i].GUBUN_TYPE == 3) {
                        data.push(json[i]);
                    }
                }

                return data;
            } catch (e) {
                return [];
            }
        },

        dayReturn(item) {
            const week = ['일', '월', '화', '수', '목', '금', '토'];
            const weekString = week[new Date(item.substring(0, 4) + '-' + item.substring(4, 6) + '-' + item.substring(6, 8)).getDay()];
            return parseInt(item.substring(4, 6)) + '월 / ' + parseInt(item.substring(6, 8)) + '일(' + weekString + ')';
        },
        prevMonth() {
            this.now_date = this.prev_date;
            this.prev_date = dateClass.prevYYYYMM(this.now_date);
            this.next_date = dateClass.nextYYYYMM(this.now_date);
            this.getData(this.now_date);
        },
        nextMonth() {
            this.now_date = this.next_date;
            this.prev_date = dateClass.prevYYYYMM(this.now_date);
            this.next_date = dateClass.nextYYYYMM(this.now_date);
            this.getData(this.now_date);
        },
        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        },

        async memberReport(uid) {
            const { data } = await axiosClass.get('/api/remote/userData/' + uid, {}, true);

            this.popupActive = true;
            this.patientUsername = data.patientData.PATIENT_USERNAME;
            this.patientAge = data.patientData.PATIENT_AGE;
            this.patientGender = data.patientData.PATIENT_GENDER_CONVERT;
            this.medicalRoomNm = data.patientData.MEDICAL_ROOM_NM;
            this.medicalRoomNumberNm = data.patientData.MEDICAL_ROOM_NUMBER_NM;
            this.medicalName = data.patientData.MEDICAL_NAME;
            this.sickNess = data.patientData.SICKNESS;
            this.plan = data.patientData.PLAN;
            this.memo = data.patientData.MEMO;
            this.chart_no = data.patientData.CHART_NO;
            this.status_name = data.patientData.STATUS_NAME;
            this.patient_phone = data.patientData.PATIENT_PHONE;
            this.in_init_date = data.patientData.IN_INIT_DATE;
            this.in_date = data.patientData.IN_DATE;
            this.out_date = data.patientData.OUT_DATE;
            this.complate_yn = data.patientData.COMPLATE_YN;
            this.meal_name = data.patientData.MEAL_NAME;
            this.medical_nm = data.patientData.MEDICAL_NM;
            this.west_medical_nm = data.patientData.WEST_MEDICAL_NAME;
            this.protector_phone = data.patientData.PROTECTOR_PHONE;
        },
        //환자 수정 팝업열기
        async onClickModifyView(uid) {
            this.$EventBus.$emit('memberView', uid);
            // try {
            //     this.popTabIdx = 1;
            //     this.openPopup1 = true;
            //     this.patientUid = uid;

            //     const { data } = await axiosClass.get('/api/remote/userData/' + uid, {}, true);

            //     this.chartNo = data.patientData.CHART_NO;
            //     this.patientUsername = data.patientData.PATIENT_USERNAME;
            //     this.sickNess = data.patientData.SICKNESS;
            //     this.gisu = data.patientData.GISU;
            //     this.jumin = data.patientData.PATIENT_JUMIN;
            //     this.patientBirthday = data.patientData.PATIENT_BIRTHDAY;
            //     this.patientGender = data.patientData.PATIENT_GENDER;
            //     this.age = data.patientData.PATIENT_AGE;
            //     this.plan = data.patientData.PLAN;
            //     this.newRe = data.patientData.NEW_RE;
            //     this.cdStatus = data.patientData.CD_STATUS;
            //     this.inInitDate = data.patientData.IN_INIT_DATE;
            //     this.inDate = data.patientData.IN_DATE;
            //     this.inTime = data.patientData.IN_TIME;
            //     this.outTime = data.patientData.OUT_TIME;
            //     this.outDate = data.patientData.OUT_DATE;
            //     this.completeYn = data.patientData.COMPLATE_YN;
            //     this.mealTime = data.patientData.MEAL_TIME;
            //     this.mealName = data.patientData.MEAL_NAME;
            //     this.mealMemo = data.patientData.MEAL_MEMO;
            //     this.medical_member_name = data.patientData.MEDICAL_NM;
            //     this.westMedicalNm = data.patientData.WEST_MEDICAL_NM;
            //     this.patientPhone = data.patientData.PATIENT_PHONE;
            //     this.address = data.patientData.ADDRESS;
            //     this.protectorPhone = data.patientData.PROTECTOR_PHONE;
            //     this.protectorYN = data.patientData.PROTECTOR_YN;
            //     this.protector = data.patientData.PROTECTOR;

            //     // 20210526 HP 추가
            //     this.bodyPart = data.patientData.BODYPART;
            //     this.diagnosisDate = data.patientData.DIAGNOSIS_DATE;
            //     this.operationDate = data.patientData.OPERATION_DATE;
            //     this.metastasisYn = data.patientData.METASTASIS_YN;
            //     this.metastasisPart = data.patientData.METASTASIS_PART;
            //     this.anticancerDate = data.patientData.ANTICANCER_DATE;
            //     this.radiotherapyDate = data.patientData.RADIOTHERAPY_DATE;
            //     this.antiagentYn = data.patientData.ANTIAGENT_YN;
            //     this.antiagent = data.patientData.ANTIAGENT;
            //     this.anamnesisYn = data.patientData.ANAMNESIS_YN;
            //     this.anamnesis = [];
            //     if (data.patientData.ANAMNESIS != '') {
            //         const anamnesisArray = data.patientData.ANAMNESIS.trim().split(',');
            //         this.anamnesis = anamnesisArray;
            //     }
            //     this.anamnesisEtc = data.patientData.ANAMNESIS_ETC;
            //     // 20210526 HP 추가

            //     this.memo = data.patientData.MEMO;
            //     this.corona = data.patientData.CORONA;
            //     this.medicalRoomNm = data.patientData.MEDICAL_ROOM_NM;

            //     this.medicalRoomNumberNm = data.patientData.MEDICAL_ROOM_NUMBER_NM;
            //     this.medicalRoomNumberCnt = data.patientData.MEDICAL_ROOM_NUMBER_CNT;

            //     this.medicalName = data.patientData.MEDICAL_NAME;
            //     this.medicalNameText = data.patientData.MEDICAL_NAME;

            //     if (this.medicalRoomNm != '') await this.medicalRoomChange('Y');
            //     if (this.medicalRoomNumberNm != '') await this.medicalRoomNumberChange('Y');
            // } catch (e) {
            //     console.log(e.response.data);
            // }
        },
        //환자 추가 및 수정 처리
        async onClickModify() {
            if (this.cdStatus != 9) {
                let checked = false;
                if (this.cdStatus < 11) {
                    let err_msg = '';
                    if (this.cdStatus == 6) {
                        if (this.medicalRoomNumberCnt == '') {
                            err_msg = '입원의 경우 베드위치는 필수 선택입니다.';
                        }
                    }
                    if (err_msg != '') {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            text: err_msg,
                            position: 'top-right',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                        });
                        return;
                    }
                }
            }

            this.juminCheck();
            // this.statusCheck(completeYn, inInitDate, inDate, outDate)
            // this.statusCheck();
            this.statusCheck(this.completeYn, this.inInitDate, this.inDate, this.outDate);
            if (!this.juminTF) return;
            const medicalName = this.medicalName == '직접입력' ? this.medicalNameText : this.medicalName;
            const sickNess = this.sickNess == '직접입력' ? this.sickNessText : this.sickNess;
            const mealMemo = this.mealMemo == '직접입력' ? this.mealMemoText : this.mealMemo;

            // 20210526 HP 추가
            let anamnesis = '';
            for (let i = 0; i < this.anamnesis.length; i++) {
                const anamnesisText = this.anamnesis[i];
                if (anamnesis != '') anamnesisText = ',' + anamnesisText;
                anamnesis += anamnesisText;
            }
            // 20210526 HP 추가

            let params = {
                patientUid: this.patientUid,
                chartNo: this.chartNo,
                patientUsername: this.patientUsername,
                sickNess: sickNess,
                gisu: this.gisu,
                jumin: this.jumin,
                patientBirthday: this.patientBirthday,
                patientGender: this.patientGender,
                age: this.age,

                plan: this.plan,
                newRe: this.newRe,
                cdStatus: this.cdStatus,
                inInitDate: this.inInitDate,
                inDate: this.inDate,
                inTime: this.inTime,
                outTime: this.outTime,
                outDate: this.outDate,
                completeYn: this.completeYn,
                mealTime: this.mealTime,
                mealName: this.mealName,
                mealMemo: mealMemo,

                breakfast_mealName: this.breakfast_mealName,
                lunch_mealName: this.lunch_mealName,
                dinner_mealName: this.dinner_mealName,
                medical_member_name: this.medical_member_name,
                westMedicalNm: this.westMedicalNm,
                patientPhone: this.patientPhone,
                address: this.address,
                protectorPhone: this.protectorPhone,
                protectorYN: this.protectorYN,
                protector: this.protector,
                medicalName: medicalName,
                memo: this.memo,
                corona: this.corona,
                medicalRoomNumberNm: this.medicalRoomNumberNm,
                medicalRoomNumberCnt: this.medicalRoomNumberCnt,
                // 20210526 HP 추가
                bodyPart: this.bodyPart,
                diagnosisDate: this.diagnosisDate,
                operationDate: this.operationDate,
                metastasisYn: this.metastasisYn,
                metastasisPart: this.metastasisPart,
                anticancerDate: this.anticancerDate,
                radiotherapyDate: this.radiotherapyDate,
                antiagentYn: this.antiagentYn,
                antiagent: this.antiagent,
                anamnesisYn: this.anamnesisYn,
                anamnesis: anamnesis,
                anamnesisEtc: this.anamnesisEtc,
                // 20210526 HP 추가
            };

            const { data } = await axiosClass.post('/api/patient/insert', params, true);
            if (!data.success) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: data.err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }
            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 등록되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
            this.openPopup1 = !this.openPopup1;

            this.patientUid = '';
            this.chartNo = 0;
            this.patientUsername = '';
            this.sickNess = '';
            this.gisu = '';
            this.jumin = '';
            this.patientBirthday = '';
            this.patientGender = 'M';
            this.age = 0;
            this.plan = '';
            this.newRe = '';
            this.cdStatus = '';
            this.inInitDate = '';
            this.inDate = '';
            this.inTime = '';
            this.outTime = '';
            this.outDate = '';
            this.completeYn = 'N';
            this.mealName = '';
            this.breakfast_mealName = '';
            this.lunch_mealName = '';
            this.dinner_mealName = '';
            this.medical_member_name = '';
            this.westMedicalNm = '';
            this.patientPhone = '';
            this.address = '';
            this.protectorPhone = '';
            this.protectorYN = 'N';
            this.medicalName = '';
            this.memo = '';
            this.corona = 0;
            // 20210526 HP 추가
            this.bodyPart = '';
            this.diagnosisDate = '';
            this.operationDate = '';
            this.metastasisYn = 'N';
            this.metastasisPart = '';
            this.anticancerDate = '';
            this.radiotherapyDate = '';
            this.antiagentYn = 'N';
            this.antiagent = '';
            this.anamnesisYn = 'N';
            this.anamnesis = [];
            this.anamnesisEtc = '';
            // 20210526 HP 추가

            this.getData('');
            console.log('ok!!!!');
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);
        },
        // 주민등록번호 검사
        juminCheck() {
            let err_msg = '';
            const jumin_1 = this.jumin.split('-')[0] || '';
            const jumin_2 = this.jumin.split('-')[1] || '';

            const patientGenderCode = jumin_2 != undefined && jumin_2.length > 0 ? jumin_2.substr(0, 1) : '';
            const genderCode_2000_Array = ['3', '4', '7', '8'];
            const genderCode_1900_Array = ['1', '2', '5', '6'];
            const genderCode_1800_Array = ['9', '0'];
            const today = dateClass.getDate('YYYYMMDD');
            const today_Y = dateClass.getDate('YYYY');
            const jumin_1_2000 = '20' + jumin_1;
            if (
                this.jumin.indexOf('-') < 0 ||
                this.jumin.length != 14 ||
                (this.jumin.match(/-/g) != null && this.jumin.match(/-/g).length != 1) ||
                isNaN(jumin_1) ||
                // isNaN(jumin_2) ||
                jumin_1.length != 6 ||
                jumin_2.length != 7 ||
                patientGenderCode == ''
            ) {
                err_msg = '주민번호를 [123456-1234567]형태로 올바르게 입력하여 주십시오.';
            } else {
                if (isNaN(patientGenderCode)) {
                    err_msg = '주민번호 성별을 올바르게 입력하여 주십시오.';
                } else if (genderCode_2000_Array.indexOf(patientGenderCode) > -1 && today < jumin_1_2000) {
                    err_msg = '2000년대의 생년월일을 확인하여 주십시오.';
                }
            }
            if (err_msg != '') {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.juminTF = false;
                return;
            } else {
                this.patientGender = patientGenderCode % 2 == 0 ? 'F' : 'M';
                let patientBirth_MD = jumin_1.substr(2, 2) + '-' + jumin_1.substr(4, 2);
                let patientBirth_Y = jumin_1.substr(0, 2);
                if (genderCode_2000_Array.indexOf(patientGenderCode) > -1) {
                    patientBirth_Y = '20' + patientBirth_Y;
                } else if (genderCode_1900_Array.indexOf(patientGenderCode) > -1) {
                    patientBirth_Y = '19' + patientBirth_Y;
                } else if (genderCode_1800_Array.indexOf(patientGenderCode) > -1) {
                    patientBirth_Y = '18' + patientBirth_Y;
                }
                this.patientBirthday = patientBirth_Y + '-' + patientBirth_MD;
                this.age = today_Y - patientBirth_Y + 1;
                this.juminTF = true;
            }
        },
        //환자 추가 및 수정 팝업닫기
        onClickModifyHide() {
            this.openPopup1 = !this.openPopup1;
        },
        //현재상태 및 신입재입 체크
        statusCheck(completeYn, inInitDate, inDate, outDate) {
            completeYn = completeYn || 'N';
            inInitDate = inInitDate || '';
            inDate = inDate || '';
            outDate = outDate || '';
            let now_status = this.cdStatus;
            let diff = dateClass.dateDiff(outDate, inDate);
            this.now_day = dateClass.getDate('YYYY-MM-DD');

            if (completeYn == 'Y') {
                // 현재 상태 : 완퇴
                this.cdStatus = '10';
                this.medicalRoomNumberNm = '완퇴';
            } else {
                // 현재 상태
                if (inInitDate == '') {
                    // 외래
                    this.cdStatus = '8';
                } else if (outDate == this.now_day) {
                    // 퇴원일
                    this.cdStatus = '12';

                    if (now_status == 7) {
                        this.medicalRoomNm = '';
                        this.medicalRoomNumberNm = '';
                        this.medicalRoomNumberCnt = '';
                    }
                } else if (inDate < this.now_day) {
                    if (diff >= 0 && diff < 6) {
                        // 가퇴원
                        this.cdStatus = '13';
                    } else if (outDate < this.now_day && inDate <= outDate) {
                        // 퇴원
                        this.cdStatus = '7';
                        this.medicalRoomNm = '';
                        this.medicalRoomNumberCnt = '';
                        this.medicalRoomNumberNm = '퇴원';
                    } else {
                        // 입원
                        this.cdStatus = '6';

                        if (now_status != 6 && now_status != 12) {
                            this.medicalRoomNm = '';
                            this.medicalRoomNumberNm = '';
                            this.medicalRoomNumberCnt = '';
                        }
                    }
                } else if (inDate == this.now_day) {
                    // 입원일
                    this.cdStatus = '11';
                    if (now_status != 6) {
                    }
                } else if (inDate > this.now_day) {
                    if (outDate < this.now_day) {
                        // 입원예정
                        this.cdStatus = '9';
                    } else if (outDate >= inDate) {
                        // 입원예정
                        this.cdStatus = '9';
                    } else if (diff >= 0 && diff < 6 && outDate <= this.now_day) {
                        // 가퇴원
                        this.cdStatus = '13';
                    } else {
                        // 입원
                        this.cdStatus = '6';
                    }
                }
            }
            // 신입재입 체크
            if (now_status == 6 && (inInitDate == '' || inDate == '')) {
                this.newRe = '오류';
            } else if (inDate > inInitDate && inInitDate != '' && inDate != '') {
                this.newRe = '재입';
            } else if (inDate == inInitDate && inInitDate != '' && inDate != '') {
                this.newRe = '신입';
            } else {
                this.newRe = '';
            }
        },
        //병동선택 change
        async medicalRoomChange(first = 'N') {
            let params = {
                medicalRoomNm: this.medicalRoomNm,
            };
            const { data } = await axiosClass.get('/api/patient/medicalRoomNumberList2', params, true);
            this.medicalRoomNumberList2 = data.medicalRoomNumberList2;

            if (first == 'N') {
                this.medicalRoomNumberNm = '';
                this.medicalRoomNumberCntList = [];
                this.medicalRoomNumberCnt = '';
            }
        },
        //병실선택 change
        async medicalRoomNumberChange(first = 'N') {
            let params = {
                medicalRoomNumberNm: this.medicalRoomNumberNm,
            };

            const { data } = await axiosClass.get('/api/patient/medicalRoomNumberCntList', params, true);

            this.medicalRoomNumberCntList = data.medicalRoomNumberCntList;

            if (first == 'N') {
                this.medicalRoomNumberCnt = '';
            }
        },
        dayReturn2(item) {
            const week = ['일', '월', '화', '수', '목', '금', '토'];
            const weekString = week[new Date(item).getDay()];
            return weekString;
        },
        // 20210526 HP 추가
        anamnesisInput() {
            this.anamnesisEtc = this.anamnesis.indexOf('기타') < 0 ? '' : this.anamnesisEtc;
        },
        // 20210526 HP 추가

        // 20210527 HP 추가
        async onClickCs() {
            this.csDatas = [];
            let params = {
                patientUid: this.patientUid,
            };

            const { data } = await axiosClass.get('/api/patient/cs', params, true);

            if (data.csDatas.length > 0) {
                this.csDatas = data.csDatas;
            }
        },
        // 20210607 HP 수정
        addClickCs() {
            const tempCsData = {
                CS_CATE_CODE: '',
                CS_CONTENT: '',
                CS_DATE: dateClass.getDate('YYYY-MM-DD'),
                CS_TIME: dateClass.getDate('HH:mm:ss'),
                CS_FAVOR_CODE: '',
                CS_ISSUE_CODE: '',
                CS_MEMBER_CODE: '',
                CS_PATH_CODE: '',
                INQUIRER: '',
                NEXT_DATE: '',
                PATIENT_UID: this.patientUid,
                PHONE: '',
                RELATION: '',
                SEQ: 0,
            };
            this.csDatas.unshift(tempCsData);
        },
        // 20210607 HP 수정
        async removeClickCs(index) {
            const csSeq = this.csDatas[index].SEQ;
            if (csSeq > 0) {
                await axiosClass.delete('/api/patient/cs/' + csSeq, true);
            }
            this.csDatas.splice(index, 1);
            this.$vs.notify({
                color: 'danger',
                title: '삭제 완료',
                text: '삭제가 완료되었습니다.',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
        },
        async saveClickCs() {
            if (this.csDatas.length < 1) {
                this.$vs.notify({
                    color: 'danger',
                    title: '오류',
                    text: '상담내역이 존재하지 않습니다.',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-check',
                });
                return;
            }
            let err_msg = '';
            let objName = '';
            for (let i = 0; i < this.csDatas.length; i++) {
                const data = this.csDatas[i];

                const csPathCode = data.CS_PATH_CODE;
                const csCateCode = data.CS_CATE_CODE;
                const csMeberCode = data.CS_MEMBER_CODE;
                const inquirer = data.INQUIRER;
                const phone = data.PHONE;
                const relation = data.RELATION;
                const csFavorCode = data.CS_FAVOR_CODE;
                const nextDate = data.NEXT_DATE;
                const csIssueCode = data.CS_ISSUE_CODE;
                const csContent = data.CS_CONTENT;
                // 20210607 HP 수정
                if (csPathCode == 0 || csPathCode == '') {
                    err_msg = '경로(를)을 입력해주세요.';
                    objName = 'csPathCode';
                } else if (csCateCode == 0 || csCateCode == '') {
                    err_msg = '문의종류(를)을 입력해주세요.';
                    objName = 'csCateCode';
                }
                // else if (csMeberCode == 0 || csMeberCode == '') {
                //     err_msg = '담당자(를)을 입력해주세요.';
                //     objName = 'csMeberCode';
                // } else if (inquirer.trim() == '') {
                //     err_msg = '문의자(를)을 입력해주세요.';
                //     objName = 'inquirer';
                // } else if (phone.trim() == '') {
                //     err_msg = '연락처(를)을 입력해주세요.';
                //     objName = 'phone';
                // } else if (relation.trim() == '') {
                //     err_msg = '관계(를)을 입력해주세요.';
                //     objName = 'relation';
                // } else if (csFavorCode == 0 || csFavorCode == '') {
                //     err_msg = '호의도(를)을 입력해주세요.';
                //     objName = 'csFavorCode';
                // } else if (nextDate.trim() == '') {
                //     err_msg = '다음일정(를)을 입력해주세요.';
                //     objName = 'nextDate';
                // } else if (csIssueCode == 0 || csIssueCode == '') {
                //     err_msg = '부정이슈 종류(를)을 입력해주세요.';
                //     objName = 'csIssueCode';
                // } else if (csContent.trim() == '') {
                //     err_msg = '상담내역(를)을 입력해주세요.';
                //     objName = 'csContent';
                // }
                // 20210607 HP 수정
                if (err_msg != '') {
                    this.$vs.notify({
                        color: 'danger',
                        title: '오류',
                        text: err_msg,
                        position: 'top-right',
                        iconPack: 'feather',
                        icon: 'icon-check',
                    });

                    if (objName == 'nextDate') {
                        const dateDiv = document.querySelectorAll('div[name="' + objName + '"]')[i];
                        const dateInput = dateDiv.querySelector('input[name="date"]');
                        dateInput.focus();
                    } else if (objName == 'csContent') {
                        document.querySelectorAll('textarea[name="' + objName + '"]')[i].focus();
                    } else {
                        document.querySelectorAll('input[name="' + objName + '"]')[i].focus();
                    }

                    return;
                }
            }

            const params = {
                csDatas: this.csDatas,
            };
            const { data } = await axiosClass.post('/api/patient/cs', params, true);
            if (!data.success) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: data.err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }
            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 등록되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
        },
        // 20210527 HP 추가

        // 20210528 HP 추가
        activeMenu2(popTabIdx) {
            if (popTabIdx == this.popTabIdx) {
                return 'activeMenu2';
            } else {
                return '';
            }
        },
        async popTabClick(popTabIdx) {
            this.popTabIdx = popTabIdx;
            if (this.popTabIdx == 2) await this.onClickCs();
            this.csPopup = !this.csPopup;
            this.openPopup1 = !this.openPopup1;
        },
        // 20210528 HP 추가
    },

    async mounted() {
        window.addEventListener('resize', this.handleResize);
        //20210607 HP tab_sum
        this.tab_sum = store.getters.getTABSUM;
        //20210607 HP tab_sum
        await this.getData('');
        console.log('mounted');

        EventBus.$on('remoteListRefresh', async () => {
            await this.getData('');
        });
    },
    computed: {
        nowDate() {
            // return this.now_date.substring(0, 4) + '년 ' + this.now_date.substring(4, 6) + '월 ' + this.now_date.substring(6, 8) + '일';
            return this.now_date.substring(0, 4) + '년 ' + this.now_date.substring(4, 6) + '월 ';
        },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};

window.addEventListener('resize', reportWindowSize);
window.addEventListener('load', reportWindowSize);
function reportWindowSize() {
    document.getElementById('calendarDiv').style.height = document.documentElement.clientHeight - 500 + 'px';
}
</script>

<style>
.reservation_div {
    vertical-align: top;
}
.reservation_div table {
    border: 0px;
    border-spacing: 0px;
    border-collapse: separate;
}

.reservation_div table tr td:nth-child(odd) {
    background-color: #c9c9c9;
    text-align: center;
    padding: 10px;
    border: 1px solid #4d4d4d;
}

.reservation_div table tr td:nth-child(even) {
    text-align: center;
    padding: 10px;
}

.reservation_div table tr td {
    border: 1px solid #4d4d4d;
}

/* css에 테그 닉네임 사용으로 페이지 변동시 모든 폰트 사이즈가 변경됨 잘못된 코드로 주석처리함 2023-04-11*/
/* table > thead > tr > th { */
/* font-weight: 400; */
/* background-color: blue; */
/* border-bottom: 1px solid rgba(0, 0, 0, 0.12); */
/* z-index: 1; */
/* border: 2px solid 439798; */
/* font-size: 0.3rem !important; 2023-04-09 수정전에도 주석 처리되어 있었음*/
/* } */

/* table > tbody > tr > td { */
/* border-bottom: 1px solid rgba(0, 0, 0, 0.12); */
/* font-size: 0.4rem !important; 2023-04-09 수정전에도 주석 처리되어 있었음*/
/* } */
/* table > tr > td { */
/* font-size: 0.5rem !important; */
/* } */
/* ----------------------------------------------------------------------- */

/* header bgcolor : #E2EFDB */
/* 신입 : #F9CD78 재입 : #32C5FF */
/* th bgcolor :  #D9E2F3*/
.header_bg {
    background-color: #e2efdb !important;
    font-size: 12px !important;
}
.th_bg {
    background-color: #d9e2f3 !important;
}
.new_bg {
    background-color: #f7e6d8 !important;
    font-size: 12px !important;
}
.re_bg {
    background-color: #e5f0db !important;
    font-size: 12px !important;
}
.tb_box {
    height: 500px;
    overflow: auto;
}
.table_header {
    position: sticky;
    top: 0 !important;
    z-index: 100;
    /* border: 3px solid red; */
}

.selectOn {
    border: 3px solid #439798;
    color: #fff;
}

.selectOff {
    border: 0px;
    color: #fff;
}

.includeIcon {
    display: initial;
}
.mx-datepicker-popup {
    z-index: 90000000 !important;
}
.activeMenu {
    border-color: #015666;
}
/* 20210528 HP 추가 */
.activeMenu2 {
    border-bottom-width: 3px !important;
    border-color: #015666;
}
/* 20210528 HP 추가 */
.tb_box {
    height: 630px;
    overflow: auto;
}
input::placeholder {
    color: rgb(185, 185, 185);
}
.hs-2 {
    height: 75px;
    text-align: left !important;
}
.hs-3 {
    height: 111px;
    text-align: left !important;
}
</style>
